export const SUPPORTX_PRIMARY_CATEGORY_MARKER =
  'supportx:conversation-primary-category:v1';

const displayNames = {
  account: 'Account',
  verification: 'Verification',
  'credit-limit': 'Credit Limit',
  'loan-application': 'Loan Application',
  card: 'Card',
  'bank-account': 'Bank Account',
  disbursement: 'Disbursement',
  repayment: 'Repayment',
  charges: 'Charges',
  complaint: 'Complaint',
  security: 'Security',
  other: 'Other',
  order: 'Order',
  'down-payment': 'Down Payment',
  device: 'Device',
  'after-sales': 'After-sales',
};

export const isSupportXPrimaryCategory = label =>
  label?.description?.split(';').includes(SUPPORTX_PRIMARY_CATEGORY_MARKER) ??
  false;

export const primaryCategoryDisplayName = title =>
  displayNames[title] ||
  String(title || '')
    .split('-')
    .filter(Boolean)
    .map(word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join(' ');

export const replacePrimaryCategory = ({
  savedLabels,
  accountLabels,
  category,
}) => {
  const categoryTitles = new Set(
    accountLabels.filter(isSupportXPrimaryCategory).map(label => label.title)
  );
  return [...savedLabels.filter(title => !categoryTitles.has(title)), category];
};
